import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import Api from 'utils/api';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import GlobalContext from 'contexts';
import translating from '../../translate.json';

import './style.scss';

function SearchLocationInput({
  field,
  Controller,
  control,
  dataField,
  errors,
}) {
  const { city, setCity } = useContext(GlobalContext);
  const [query, setQuery] = useState(
    field.name === 'street' ? { שם_ישוב: city } : ''
  );
  const [records, setRecords] = useState([]);
  const [fullRecords, setFullRecords] = useState([]);
  const getData = () => {
    var data = {
      resource_id:
        field.name === 'street'
          ? 'a7296d1a-f8c9-4b70-96c2-6ebb4352f8e3'
          : '5c78e9fa-c2e2-4771-93ff-7f400a12f7ba',
      limit: 50000,
      q: query,
    };
    let url = `https://data.gov.il/api/3/action/datastore_search?resource_id=${data.resource_id}&limit=${data.limit}`;
    if (data.q !== '') url += `&q=${JSON.stringify(data.q)}`;
    Api.get(url, { withCredentials: false }).then((res) => {
      const records = res?.data?.result?.records;
      let full = [];
      for (let i = 0; i < records.length; i++) {
        let record = records[i][field.name === 'city' ? 'שם_ישוב' : 'שם_רחוב'];
        full[i] = record;
        if (record?.length > 15) record = `${record.substr(0, 15)}...`;
        records[i] = record;
      }
      setFullRecords(full);
      setRecords(records);
    });
  };

  useEffect(() => {
    if (field.name === 'street' && !city) return;
    else getData();
  }, [query]);

  useEffect(() => {
    setQuery(field.name === 'street' ? { שם_ישוב: city } : '');
  }, [city]);

  return (
    <div className="search-location-input">
      <Controller
        required={true}
        name={field?.name}
        control={control}
        rules={{
          required: field.required ? translating.requiredMsg : false,
        }}
        defaultValue={''}
        render={({ field: { onChange } }) => (
          <Autocomplete
            classes={{ root: 'addressInput' }}
            defaultValue={`${dataField ? dataField.substr(0, 15) : ''}`}
            options={records}
            onChange={(e, value) => {
              let index = records?.indexOf(value);
              if (index > -1) {
                if (field.name === 'city') setCity(fullRecords[index]);
                onChange(fullRecords[index]);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                className={`${errors?.[field.name] ? 'error' : ''}`}
                classes={{ root: 'rootInput' }}
              />
            )}
          />
        )}
      />
    </div>
  );
}

export default SearchLocationInput;

SearchLocationInput.propTypes = {
  field: PropTypes.any,
  Controller: PropTypes.any,
  control: PropTypes.any,
  dataField: PropTypes.string,
  errors: PropTypes.any,
};
